import * as React from 'react';

import {Button} from '../button/button';
import {colors} from '../colors/colors';
// @ts-expect-error
import {CogIcon} from '../icon/svg/cog-icon';
// @ts-expect-error
import {UpgradeArrowIcon} from '../icon/svg/upgrade-arrow-icon';

import styles from './customize-button.module.css';

type Props = {
    onClick: () => void;
    gated: boolean;
};

export function CustomizeButton(props: Props) {
    const IconComponent = props.gated ? UpgradeIcon : CogIcon;

    return (
        <div id='for-intercom-customize-button' className={styles['action-button']}>
            <Button icon={IconComponent} onClick={props.onClick} size='big'>
                Customize fields
            </Button>
        </div>
    );
}

function UpgradeIcon() {
    return <UpgradeArrowIcon size={18} wrapWithDiv={false} color={colors.blue} />;
}
